"use client";

import { useEffect } from "react";
import Link from "next/link";
import Image from "next/image";
import { useAppContext } from "@/context/Context";
import { useSession } from "next-auth/react";
import logoLight from "../../public/images/logo/logo.webp";
import logoDark from "../../public/images/light/logo/logo-dark.webp";
import Nav from "./Nav";

/**
 * Componente PopupMobileMenu que muestra el menú móvil emergente.
 * Se encarga de gestionar la visibilidad del menú en función del tamaño de la ventana y del estado de la sesión.
 *
 * @returns {JSX.Element} - Renderizado del menú móvil emergente.
 */
const PopupMobileMenu = () => {
  const { activeMobileMenu, setActiveMobileMenu, isLightTheme } =
    useAppContext();
  const { data: session } = useSession(); // Obtiene la sesión

  // Ajusta la visibilidad del menú móvil al redimensionar la ventana.
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 992) {
        setActiveMobileMenu(true);
      }
    };

    window.addEventListener("resize", handleResize);
    // Llamada inicial para ajustar el estado según el tamaño actual de la ventana.
    handleResize();

    return () => window.removeEventListener("resize", handleResize);
  }, [setActiveMobileMenu]);

  return (
    <div className={`popup-mobile-menu ${activeMobileMenu ? "" : "active"}`}>
      {/* Capa de fondo que al hacer clic cierra el menú */}
      <div
        className="bg"
        onClick={() => setActiveMobileMenu(!activeMobileMenu)}
      ></div>
      <div className="inner-popup">
        <div className="header-top">
          <div className="logo">
            <Link href="/">
              <Image
                className="logo-light"
                src={isLightTheme ? logoLight : logoDark}
                width={116}
                height={30}
                alt="Corporate Logo"
              />
            </Link>
          </div>
          <div className="close-menu">
            <button
              className="close-button"
              onClick={() => setActiveMobileMenu(!activeMobileMenu)}
            >
              <i className="fa-sharp fa-regular fa-x"></i>
            </button>
          </div>
        </div>
        <div className="content">
          <Nav />
          {/* Si no hay sesión, se muestra un separador */}
          {!session && (
            <>
              <div className="rbt-sm-separator"></div>
              <ul className="dashboard-mainmenu rbt-default-sidebar-list">
                <li>
                  <Link href="/iniciar-sesion" className="nav-link">
                    <i className="fa-solid fa-right-to-bracket"></i>Iniciar
                    sesión
                  </Link>
                </li>
              </ul>
            </>
          )}
        </div>
        {/* Renderiza el botón "Iniciar sesión" solo si no hay sesión activa */}
        {!session && (
          <div className="header-btn d-block d-md-none">
            <Link className="btn-default" href="/iniciar-sesion">
              Regístrate gratis
            </Link>
          </div>
        )}
      </div>
    </div>
  );
};

export default PopupMobileMenu;
